<div class="lum-c-order-fulfillment-status-update lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{ data.title }}</span>
  </div>
  <form [formGroup]="form" (submit)="onSubmit()">
    <div class="order-fulfillment-status-update-form__wrapper">
      <div class="lum-modal__body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <div class="lum-label">Select Status</div>
              <mat-select class="lum-select" formControlName="orderStatus">
                <mat-option
                  *ngFor="let status of orderStatusLookups; trackBy: trackByValue"
                  [value]="status"
                >
                  {{ status }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
        <div class="lum-modal__footer">
          <div class="flex ml-auto lum-modal__action">
            <button
              type="button"
              class="lum-button lum-button--secondary mr-2"
              mat-button
              (click)="onClose()"
            >
              Cancel
              <i class="fas fa-window-close"></i>
            </button>
            <button
              mat-button
              type="submit"
              class="lum-button"
              [disabled]="form.invalid"
            >
              Save
              <i class="fas fa-save"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
